import React, { useState } from "react";
import { adminFetch } from "../../api/adminApi";
import { AdminCard, AdminLabel, AdminPageHeader } from "./AdminPageHeader";
import AdminRichEditor from "./AdminRichEditor";

export default function AdminPublish() {
  const [headline, setHeadline] = useState("");
  const [bodyHtml, setBodyHtml] = useState("");
  const [summary, setSummary] = useState("");
  const [category, setCategory] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setMsg("");
    try {
      const data = await adminFetch("/v1/admin/articles/publish", {
        method: "POST",
        body: JSON.stringify({
          headline,
          body_html: bodyHtml,
          summary,
          category,
        }),
      });
      setMsg("Article published successfully.");
      setHeadline("");
      setBodyHtml("");
      setSummary("");
      setCategory("");
    } catch (e2) {
      setErr(e2.data?.error || e2.message);
    }
  };

  return (
    <div>
      <AdminPageHeader
        kicker="Compose"
        title="New article"
        description="Write and publish directly to the feed. Use the live preview to check formatting before publishing."
      />

      {err && (
        <div className="mb-6 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
          {err}
        </div>
      )}
      {msg && (
        <div className="mb-6 rounded-xl border border-[#CCFF00]/25 bg-[#CCFF00]/[0.08] px-4 py-3 text-sm text-[#CCFF00]">
          {msg}
        </div>
      )}

      <AdminCard>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <AdminLabel>Headline</AdminLabel>
            <input
              className="pitch-admin-input"
              placeholder="Breaking headline"
              value={headline}
              onChange={(e) => setHeadline(e.target.value)}
              required
            />
          </div>
          <div className="grid gap-6 md:grid-cols-2">
            <div>
              <AdminLabel>Summary (optional)</AdminLabel>
              <input
                className="pitch-admin-input"
                value={summary}
                onChange={(e) => setSummary(e.target.value)}
              />
            </div>
            <div>
              <AdminLabel>Category (optional)</AdminLabel>
              <input
                className="pitch-admin-input"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              />
            </div>
          </div>
          <div>
            <AdminLabel>Body</AdminLabel>
            <AdminRichEditor
              value={bodyHtml}
              onChange={setBodyHtml}
              placeholder="Lead with the news. Use headings and blockquotes for scanability…"
              helperText="Your article will go live in all active client feeds once published."
              size="large"
              showPreview
            />
          </div>
          <button type="submit" className="pitch-admin-btn-primary">
            Publish to global feed
          </button>
        </form>
      </AdminCard>
    </div>
  );
}